module.exports = __webpack_public_path__ + "average-price.svg?1f033c6085aff934d13e9c1901f534f3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/average-price.svg
// module id = 277
// module chunks = 2